var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('core-monaco-editor',{staticStyle:{"height":"100vh"},attrs:{"language":"json","readOnly":true},model:{value:(_vm.displayedData),callback:function ($$v) {_vm.displayedData=$$v},expression:"displayedData"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }